// Shop Related grid: follows the PLP sticky bar's grid view (component-sticky-filter-bar.js).
if (!customElements.get('featured-collection-grid')) {
  class FeaturedCollectionGrid extends HTMLElement {
    constructor() {
      super();
      this.onViewChange = this.onViewChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('sticky-filter-bar:view-change', this.onViewChange);

      // The bar may have announced its default view before this grid was defined.
      const view = document.querySelector('sticky-filter-bar')?.activeView;
      if (view) this.setView(view);
    }

    disconnectedCallback() {
      document.removeEventListener('sticky-filter-bar:view-change', this.onViewChange);
    }

    /** @param {CustomEvent<{ view: string|null }>} event */
    onViewChange(event) {
      this.setView(event.detail.view);
    }

    /** @param {string|null} view */
    setView(view) {
      if (view) {
        this.dataset.gridView = view;
      } else {
        delete this.dataset.gridView;
      }

      // Re-measure before the next paint so slides don't flash at their old pixel width.
      for (const card of this.querySelectorAll('product-card')) {
        card.mediaSwiper?.update();
      }
    }
  }

  customElements.define('featured-collection-grid', FeaturedCollectionGrid);
}
